import type { MenuSelectFilterChange, TextFilterChange } from "@relex-solutions/fragments/Table"
import { CUSTOMER_COLUMN_IDS } from "@/domains/customers/constants/customerTableColumns"
import type { RelationshipSubType, RelationshipType } from "@/domains/customers/types/Customer"

export const getTextFilterValue = (filter: TextFilterChange | MenuSelectFilterChange<string> | undefined): string => {
  if (!filter || !filter.isActive) return ""
  if (filter.type === "text" && "value" in filter) {
    return (filter.value as string) || ""
  }
  return ""
}

export const getMenuSelectFilterValue = <T extends string>(
  filter: TextFilterChange | MenuSelectFilterChange<string> | undefined,
  defaultValue: T
): T => {
  if (!filter || !filter.isActive) return defaultValue
  if (filter.type === "menu-select" && "value" in filter && Array.isArray(filter.value) && filter.value.length > 0) {
    return filter.value[0] as T
  }
  return defaultValue
}

export type CustomerListFilterChange = TextFilterChange | MenuSelectFilterChange<string>

export type CustomerListQueryParamUpdates = Partial<{
  page: number
  salesforceId: string | undefined
  relationshipType: RelationshipType | undefined
  relationshipSubType: RelationshipSubType | undefined
  searchTerm: string | undefined
  sdmEmail: string | undefined
}>

export function getCustomerListQueryParamUpdates(change: CustomerListFilterChange): CustomerListQueryParamUpdates {
  const updates: CustomerListQueryParamUpdates = { page: 0 }

  if (!change.isActive) {
    if (change.id === CUSTOMER_COLUMN_IDS.NAME) updates.searchTerm = undefined
    else if (change.id === CUSTOMER_COLUMN_IDS.SALESFORCE_ID) updates.salesforceId = undefined
    else if (change.id === CUSTOMER_COLUMN_IDS.SDM_EMAIL) updates.sdmEmail = undefined
    else if (change.id === CUSTOMER_COLUMN_IDS.RELATIONSHIP_TYPE) updates.relationshipType = undefined
    else if (change.id === CUSTOMER_COLUMN_IDS.SUB_TYPE) updates.relationshipSubType = undefined
    return updates
  }

  if (change.type === "text") {
    const value = ("value" in change ? change.value : undefined) || undefined
    if (change.id === CUSTOMER_COLUMN_IDS.NAME) updates.searchTerm = value
    else if (change.id === CUSTOMER_COLUMN_IDS.SALESFORCE_ID) updates.salesforceId = value
    else if (change.id === CUSTOMER_COLUMN_IDS.SDM_EMAIL) updates.sdmEmail = value
    return updates
  }

  if (change.type === "menu-select") {
    const value = change.value[0] || undefined
    if (change.id === CUSTOMER_COLUMN_IDS.RELATIONSHIP_TYPE) {
      updates.relationshipType = value as RelationshipType | undefined
    } else if (change.id === CUSTOMER_COLUMN_IDS.SUB_TYPE) {
      updates.relationshipSubType = value as RelationshipSubType | undefined
    }
  }

  return updates
}
